/**
 * Static fixture used to populate Handlebars context when previewing a
 * PDF template in the editor. Matches the shape oo-job-service builds
 * at PDF-render time (see DownloadJobConfirmationFor{Customer,Consultant}Handler).
 *
 * Keep field names aligned with what the backend actually passes —
 * mismatches mean preview lies about what the real PDF will render.
 */
export const PDF_TEMPLATE_PREVIEW_CONTEXT = {
	job: {
		id: "demo-job-id",
		orderNumber: "2024-0001",
		startDate: "2024-09-23",
		description: "Vikariat under semesterperioden.",
		customerDescription: "Förskola med 45 barn fördelade på tre avdelningar.",
		customerOrderNumber: "KO-987",
		purchaseOrderNo: "PO-12345",
		invoiceReference: "Anna Andersson",
		organisation: { id: "demo-org-id" },
		customer: { id: "demo-customer-id" },
		address: {
			address1: "Solvägen 12",
			postalCode: "113 26",
			city: "Stockholm",
		},
		contactPersons: [
			{
				firstName: "Anna",
				lastName: "Andersson",
				email: "anna@example.com",
				phone: "070-111 22 33",
			},
		],
	},
	customer: {
		id: "demo-customer-id",
		name: "Solgården Förskola",
		customerNumber: "K-1042",
	},
	service: "Förskollärare",
	skills: "Specialpedagog, Språkutvecklare",
	consultant: {
		id: "demo-consultant-id",
		firstName: "Erik",
		lastName: "Eriksson",
		email: "erik@example.com",
	},
	contactPerson: {
		firstName: "Anna",
		lastName: "Andersson",
		email: "anna@example.com",
		phone: "070-111 22 33",
		profile: { phoneNumber: "070-111 22 33" },
	},
	shiftsDisplay: [
		"2024-09-23 08:00 - 16:00 (0,5 tim rast) - Erik Eriksson",
		"2024-09-24 08:00 - 16:00 (0,5 tim rast) - Erik Eriksson",
		"2024-09-25 08:00 - 16:00 (0,5 tim rast) - Erik Eriksson",
	],
};
